import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { FormModal } from './FormModal'
import { useDeleteCall } from '../../lib/api/delete'
import { NoDataCard } from '../../common/NoDataCard'
import { ListCard } from '../dataViews/ListCard'
import { List } from '../dataViews/List'
import { QRCodeForm } from '../dataViews/QRCodeForm'
import { Form } from '../../common/form/Form'
import { Pagination } from '../dataViews/Pagination'
import { handleSearch, sortBy, updateResult } from '../../lib/uiHelper'
import selectDown from '../../assets/images/select-down.svg'
import { FilteredRows } from './FilteredRows'
import { DocManager } from '../dataViews/DocManager'
import { Exams } from './Exams'
import { ExamSchedule } from './ExamSchedule'

// var quality = 60
// var timeout = 10

export const BasicForm = ({
  defaultData,
  envData,
  routeData,
  authDetails,
  modSchema = JSON.parse(routeData.apiEndPointSchema),
  isLocalEnvironment,
}) => {
  const [next, setNext] = React.useState(modSchema.form.view?.dataPerRow || 10)
  const queryParams = new URLSearchParams(window.location.search)
  const addMode = queryParams.get('add')
  const [openFormModal, setOpenFormModal] = React.useState(false)
  const [openChildFormModal, setOpenChildFormModal] = React.useState(false)
  const [dataChildFormModal, setDataChildFormModal] = React.useState(null)
  const [openEditFormModal, setOpenEditFormModal] = React.useState(false)
  const [selectEditFormModal, setSelectEditFormModal] = React.useState(null)
  const [isViewOnly, setIsViewOnly] = React.useState(false)
  const [allSFSData, setAllSFSData] = React.useState(null)
  const deleteCallMutation = useDeleteCall()
  // Store sortby order i.e. ascending or descending
  const [sortType, setSortType] = React.useState('ascending')

  const [isSearch, setIsSearch] = React.useState(false)

  const [currentPage, setCurrentPage] = React.useState(1)
  const [currentRowPage, setCurrentRowPage] = React.useState(1)
  const [activeModalForm, setActiveModalForm] = React.useState(null)
  const [activeRowForm, setActiveRowForm] = React.useState(false)
  const [docManager, setDocManager] = React.useState(false)
  const [enableEdit, setEnableEdit] = React.useState(false)
  const [editData, setEditData] = React.useState(null)
  const [deleteData, setDeleteData] = React.useState(null)
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)
  const [manageExamModal, setManageExamModal] = React.useState(false)
  const [manageExamScheduleModal, setManageExamScheduleModal] = React.useState(false)
  // const [fpError, setFPError] = React.useState(false)
  // const [fpResponse, setFPResponse] = React.useState(null)

  const handlePage = (page) => {
    sessionStorage.setItem(modSchema.moduleName + 'pageActive', page)
    setCurrentPage(page)
  }

  const handleRowPage = (page) => {
    sessionStorage.setItem(modSchema.moduleName + 'rowPageActive', page)
    setCurrentRowPage(page)
  }

  const handleMoreData = () => {
    setNext(next + (modSchema.form.view?.dataPerRow || 0))
  }

  const childFormModalOpen = (schema) => {
    setDataChildFormModal(schema)
    setOpenChildFormModal(true)
  }

  const childFormModalClose = () => {
    setDataChildFormModal(null)
    setOpenChildFormModal(false)
  }

  const openFormEdit = (data, viewOnly = false) => {
    if (viewOnly === true) {
      setIsViewOnly(true)
    }
    setOpenEditFormModal(true)
    setSelectEditFormModal(data)
  }

  const noRowFormAccess = () => {
    let accessTo = true
    modSchema.noRowFormAccessTo &&
      modSchema.noRowFormAccessTo.length > 0 &&
      modSchema.noRowFormAccessTo.map((e) => {
        if (authDetails.role === e) {
          accessTo = false
          return false
        }
      })
    return accessTo
  }

  const noModalRowFormAccess = () => {
    let accessTo = true
    modSchema.noModalRowFormAccessTo &&
      modSchema.noModalRowFormAccessTo.length > 0 &&
      modSchema.noModalRowFormAccessTo.map((e) => {
        if (authDetails.role === e) {
          accessTo = false
          return false
        }
      })
    return accessTo
  }

  const openEdit = (data) => {
    setEnableEdit(true)
    setEditData(data)
  }

  const closeEdit = () => {
    setEnableEdit(false)
    setEditData(null)
  }

  const openDelete = (data, modalForm) => {
    setDeleteConfirm(true)
    setDeleteData({ data, modalForm })
  }

  const closeDelete = () => {
    setDeleteConfirm(false)
    setDeleteData(null)
  }

  const onDelete = async () => {
    await deleteCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/deleteData',
        apiEndpoint: deleteData.modalForm.update.formAPI,
        parentAPI: deleteData.modalForm.update.parentAPI,
        id: deleteData.modalForm.update.isDeleteIdObject
          ? deleteData.data[deleteData.modalForm.update.deleteIdObject[0]][
              deleteData.modalForm.update.deleteIdObject[1]
            ]
          : deleteData.data[deleteData.modalForm.update.id],
        messageTitle: deleteData.modalForm.update.deleteMessage.title,
        message: deleteData.modalForm.update.deleteMessage.message,
        isDynamic: true,
        params: '',
      })
      .then(() => {
        closeDelete()
      })
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-col-12">
        <div
          className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
          style={{ display: 'flex' }}
        >
          <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
          <div className="trtui-page-title-right">
            {modSchema.form.crud && modSchema.form.crud > 2 ? (
              <button
                type="button"
                className="trtui-btn trtui-btn-secondary trtui-add-btn"
                onClick={() => setOpenFormModal(true)}
              >
                <i className="ri-add-line align-bottom me-1"></i> Add
              </button>
            ) : (
              <div style={{ padding: '1.2rem' }}> </div>
            )}
            {modSchema.searchFilter && modSchema.filterBy && (
              <>
                {' '}
                <button
                  type="button"
                  className="trtui-btn trtui-btn-success"
                  onClick={() => setIsSearch(!isSearch)}
                >
                  Filter{' '}
                  {isSearch ? (
                    <i className="ri-arrow-drop-up-line trtui-align-bottom me-1"></i>
                  ) : (
                    <i className="ri-arrow-drop-down-line trtui-align-bottom me-1"></i>
                  )}
                </button>
              </>
            )}
          </div>
        </div>
        {modSchema.searchFilter && modSchema.searchFilter.searchTitle && (
          <div className="trtui-card">
            <div className="trtui-card-header trtui-border-0">
              <div className="trtui-row trtui-align-items-center trtui-gy-3">
                <div className="trtui-col-md-6 trtui-col-sm-4">
                  <div className="trtui-search-box">
                    <input
                      type="text"
                      className="trtui-form-control trtui-search"
                      onChange={(e) => handleSearch(e, setAllSFSData, modSchema, allSFSData)}
                      placeholder={modSchema.searchFilter.searchTitle}
                    />
                    <i className="ri-search-line trtui-search-icon" />
                  </div>
                </div>
                {modSchema.searchFilter.sortBy && modSchema.searchFilter.sortBy.length > 0 && (
                  <>
                    <div className="trtui-col-md-3 trtui-col-sm-4">
                      <div>
                        <select
                          className="trtui-form-select trtui-text-muted"
                          style={{
                            '--vz-form-select-bg-img': `url("${selectDown}")`,
                          }}
                          onChange={(e) =>
                            sortBy(
                              e.target.value,
                              setAllSFSData,
                              modSchema,
                              allSFSData,
                              sortType,
                              setSortType,
                            )
                          }
                        >
                          <option value={''}>Order By</option>
                          {modSchema.searchFilter.sortBy &&
                            modSchema.searchFilter.sortBy.length > 0 &&
                            modSchema.searchFilter.sortBy.map((sort, sortInd) => (
                              <option key={sortInd} value={sort.opt}>
                                {sort.val}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="trtui-col-md-3 trtui-col-sm-4">
                      <div>
                        <select
                          defaultValue={'DEFAULT'}
                          className="trtui-form-select trtui-text-muted"
                          style={{
                            '--vz-form-select-bg-img': `url("${selectDown}")`,
                          }}
                          onChange={(e) =>
                            updateResult(e.target.value, modSchema, setSortType, sortType)
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Sort By
                          </option>
                          <option value="ascending">Ascending</option>
                          <option value="descending">Descending</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {isSearch && (
              <div
                className="trtui-card-body trtui-border trtui-border-dashed trtui-border-end-0 trtui-border-start-0"
                style={{
                  animationName: 'DropDownSlide',
                  animationDuration: '.3s',
                  animationFillMode: 'both',
                }}
              >
                <form>
                  <div className="trtui-row trtui-g-3">
                    <div className="trtui-col-12 trtui-mt-0">
                      <strong>Filter</strong>
                    </div>
                    <div className="trtui-col-md-2 trtui-col-sm-6">
                      <div>
                        <label>From</label>
                        <input
                          type="date"
                          className="trtui-form-control trtui-flatpickr-input"
                          placeholder="Select date"
                        />
                      </div>
                    </div>
                    <div className="trtui-col-md-2 trtui-col-sm-6">
                      <div>
                        <label>To</label>
                        <input
                          type="date"
                          className="trtui-form-control trtui-flatpickr-input"
                          placeholder="Select date"
                        />
                      </div>
                    </div>
                    <div className="trtui-col-xxl-2 trtui-col-sm-4">
                      <div>
                        <label>Class</label>
                        <Select
                          className="trtui-form-select trtui--select"
                          style={{ color: '#000000' }}
                          options={[
                            { value: 'chocolate', label: 'Chocolate' },
                            { value: 'strawberry', label: 'Strawberry' },
                            { value: 'vanilla', label: 'Vanilla' },
                          ]}
                        />
                      </div>
                    </div>
                    <div className="trtui-col-xxl-2 trtui-col-sm-4">
                      <div>
                        <label>Academic Year</label>
                        <Select
                          className="trtui-form-select trtui--select"
                          style={{ color: '#000000' }}
                          options={[
                            { value: 'chocolate', label: 'Chocolate' },
                            { value: 'strawberry', label: 'Strawberry' },
                            { value: 'vanilla', label: 'Vanilla' },
                          ]}
                        />
                      </div>
                    </div>
                    <div className="trtui-col-xxl-1 trtui-col-sm-4">
                      <div style={{ right: '1rem', position: 'unset' }}>
                        <button type="button" className="trtui-btn trtui-btn-primary">
                          <i className="ri-equalizer-fill trtui-me-1 trtui-align-bottom" />
                          Apply
                        </button>{' '}
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-light"
                          onClick={() => setIsSearch(!isSearch)}
                        >
                          <i className="ri-restart-line trtui-me-1 trtui-align-bottom" />
                        </button>{' '}
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-info"
                          onClick={() => setIsSearch(!isSearch)}
                        >
                          <i className="ri-close-line trtui-me-1 trtui-align-bottom" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
      {defaultData.formData === undefined && (
        <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} schemaNotConfigured={true} />
      )}
      {modSchema.hasExamModules && (
        <div className="trtui-row trtui-mb-3">
          <div className="trtui-col-6">
            <button
              onClick={() => setManageExamModal(true)}
              className="trtui-btn trtui-btn-primary"
            >
              Manage Exams
            </button>
          </div>
          <div className="trtui-col-6" style={{ textAlign: 'end' }}>
            <button
              onClick={() => setManageExamScheduleModal(true)}
              className="trtui-btn trtui-btn-primary trtui-ms-auto"
            >
              Exam Schedule
            </button>
          </div>
        </div>
      )}
      {defaultData.formData?.length <= 0 ? (
        <div className="trtui-col-12 trtui-project-card">
          <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
        </div>
      ) : modSchema.form?.view?.formType === 'listCard' ? (
        <div key={`${allSFSData}${sortType}`} className="trtui-row">
          {defaultData.formData?.slice(0, next).map((list, listIndex) => (
            <ListCard
              key={listIndex}
              crud={modSchema.form?.crud}
              listKey={listIndex}
              openEditFormModal={openEditFormModal}
              setOpenEditFormModal={setOpenEditFormModal}
              envData={envData}
              routeData={routeData}
              dataToDisplay={modSchema.form.view.displayData}
              data={list}
              modSchema={modSchema}
              defaultData={defaultData}
              next={next}
              selectEditFormModal={selectEditFormModal}
              openFormEdit={openFormEdit}
              isViewOnly={isViewOnly}
              setIsViewOnly={setIsViewOnly}
              authDetails={authDetails}
              isLocalEnvironment={isLocalEnvironment}
            />
          ))}
        </div>
      ) : modSchema.form?.view?.formType === 'list' ? (
        <List
          openEditFormModal={openEditFormModal}
          crud={modSchema.form?.crud}
          setOpenEditFormModal={setOpenEditFormModal}
          envData={envData}
          routeData={routeData}
          dataToDisplay={modSchema.form.view.displayData}
          modSchema={modSchema}
          data={defaultData}
          next={next}
          selectEditFormModal={selectEditFormModal}
          openFormEdit={openFormEdit}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
          authDetails={authDetails}
          isLocalEnvironment={isLocalEnvironment}
        />
      ) : modSchema.form?.view?.formType === 'listQRCodeCard' ? (
        <QRCodeForm
          openEditFormModal={openEditFormModal}
          isLocalEnvironment={isLocalEnvironment}
          crud={modSchema.form?.crud}
          setOpenEditFormModal={setOpenEditFormModal}
          envData={envData}
          routeData={routeData}
          data={defaultData}
          defaultData={defaultData}
          modSchema={modSchema}
          next={next}
          selectEditFormModal={selectEditFormModal}
          openFormEdit={openFormEdit}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
        />
      ) : (
        <>
          <div className="trtui-row">
            <div className="trtui-col trtui-project-card">
              <div className="trtui-card trtui-card-height-100">
                <div className="trtui-card-body">
                  <div className="trtui-d-flex trtui-flex-column trtui-h-100">
                    <Form
                      key={`${modSchema.moduleName}${currentPage}${defaultData.formData}update`}
                      crud={modSchema.form?.crud}
                      authDetails={authDetails}
                      defaultData={defaultData.formData[currentPage - 1]}
                      formSchema={modSchema.form.update}
                      isUpdate={true}
                      moduleSchema={modSchema}
                      isLocalEnvironment={isLocalEnvironment}
                      envData={envData}
                    />
                    {modSchema.hasDocuments && (
                      <div className="trtui-col-12">
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-primary trtui-btn-sm"
                          onClick={() => setDocManager(true)}
                          style={{ float: 'inline-end' }}
                        >
                          <i className="ri-folder-2-line trtui-align-bottom trtui-me-1" /> Documents
                        </button>
                      </div>
                    )}
                    <div>
                      {defaultData.formData.length > 1 && (
                        <div className="trtui-mt-3">
                          <Pagination
                            currentPage={currentPage}
                            totalCount={defaultData.formData.length}
                            siblingCount={1}
                            pageSize={1}
                            onPageChange={handlePage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {noRowFormAccess() && modSchema.isRowForm && (
            <div className="trtui-col-xxl-12 trtui-col-sm-12 trtui-project-card">
              <div className="trtui-card trtui-card-height-100">
                <div className="trtui-card-body">
                  <div className="trtui-accordion" id="default-accordion-example">
                    <div className="trtui-accordion-item">
                      <h2 className="trtui-accordion-header" id="headingOne">
                        <button
                          className="trtui-accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          onClick={() => setActiveRowForm(!activeRowForm)}
                        >
                          {modSchema.rowForm.formTitle}
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className={`trtui-accordion-collapse trtui-collapse ${
                          activeRowForm ? 'trtui-show' : ''
                        }`}
                        aria-labelledby="headingOne"
                        data-bs-parent="#default-accordion-example"
                      >
                        <div className="trtui-accordion-body">
                          <>
                            {modSchema.rowForm.filterBy ? (
                              <>
                                <button
                                  className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-float-right"
                                  onClick={() => childFormModalOpen(modSchema.rowForm.create)}
                                >
                                  <i className="ri-add-line" /> Add
                                </button>
                                <FilteredRows
                                  key={`${currentRowPage}${modSchema.moduleName}${currentPage}${
                                    defaultData.formData[currentPage - 1]
                                  }update`}
                                  filterType={modSchema.rowForm.filterByValue}
                                  currentPage={currentPage}
                                  setOpenFormModal={setOpenFormModal}
                                  defaultData={
                                    defaultData.formData[currentPage - 1][
                                      modSchema.rowForm.rowDataArray
                                    ]
                                  }
                                  envData={envData}
                                  formSchema={modSchema.rowForm.update}
                                  modSchema={modSchema.rowForm.update}
                                  schema={modSchema}
                                  isUpdate={true}
                                  isRowForm={true}
                                />
                              </>
                            ) : (
                              <>
                                <button
                                  className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-float-right"
                                  onClick={() => childFormModalOpen(modSchema.rowForm.create)}
                                >
                                  <i className="ri-add-line" /> Add
                                </button>
                                {defaultData.formData[currentPage - 1][
                                  modSchema.rowForm.rowDataArray
                                ].length > 0 && (
                                  <Form
                                    key={`${currentRowPage}${modSchema.moduleName}${currentPage}${
                                      defaultData.formData[currentPage - 1]
                                    }update`}
                                    crud={modSchema.form?.crud}
                                    setOpenFormModal={setOpenFormModal}
                                    defaultData={
                                      defaultData.formData[currentPage - 1][
                                        modSchema.rowForm.rowDataArray
                                      ][currentRowPage - 1]
                                    }
                                    envData={envData}
                                    formSchema={modSchema.rowForm.update}
                                    modSchema={modSchema.rowForm.update}
                                    moduleSchema={modSchema}
                                    isLocalEnvironment={isLocalEnvironment}
                                    isUpdate={true}
                                    isRowForm={true}
                                  />
                                )}

                                {defaultData.formData[currentPage - 1][
                                  modSchema.rowForm.rowDataArray
                                ].length > 1 && (
                                  <div className="trtui-mt-3">
                                    <Pagination
                                      key={`${currentPage}${currentRowPage}`}
                                      currentPage={currentRowPage}
                                      totalCount={
                                        defaultData.formData[currentPage - 1][
                                          modSchema.rowForm.rowDataArray
                                        ].length
                                      }
                                      siblingCount={1}
                                      pageSize={1}
                                      onPageChange={handleRowPage}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {noModalRowFormAccess() && modSchema.isModalRowForm && (
            <div className="trtui-col-xxl-12 trtui-col-sm-12 trtui-project-card">
              <div className="trtui-card trtui-card-height-100">
                <div className="trtui-card-body">
                  <div className="trtui-accordion" id="default-accordion-example">
                    {modSchema.modalRowForm.map((modalForm, modalFormIndex) => (
                      <div key={modalFormIndex} className="trtui-accordion-item">
                        <h2 className="trtui-accordion-header" id="headingOne">
                          <button
                            className="trtui-accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                            onClick={() => setActiveModalForm(modalFormIndex)}
                          >
                            {modalForm.formTitle}
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className={`trtui-accordion-collapse trtui-collapse ${
                            activeModalForm === modalFormIndex ? 'trtui-show' : ''
                          }`}
                          aria-labelledby="headingOne"
                          data-bs-parent="#default-accordion-example"
                        >
                          <div className="trtui-accordion-body">
                            {modalForm.filterBy ? (
                              <>
                                <FilteredRows
                                  key={`${
                                    modalForm.moduleName
                                  }${currentPage}${defaultData.formData[currentPage - 1]}update`}
                                  filterType={modalForm.filterByValue}
                                  childFormModalOpen={childFormModalOpen}
                                  currentPage={currentPage}
                                  setOpenFormModal={setOpenFormModal}
                                  defaultData={
                                    defaultData.formData[currentPage - 1][modalForm.rowDataArray]
                                  }
                                  envData={envData}
                                  formSchema={modalForm.update}
                                  modSchema={modalForm.update}
                                  schema={modalForm}
                                  isUpdate={true}
                                  isRowForm={true}
                                />
                              </>
                            ) : (
                              <>
                                <>
                                  {!modalForm.noAdd && !modalForm.noActions && (
                                    <button
                                      className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-float-right trtui-float-right"
                                      onClick={() => childFormModalOpen(modalForm.create)}
                                    >
                                      <i className="ri-add-line" /> Add
                                    </button>
                                  )}
                                  {defaultData.formData[currentPage - 1][modalForm.rowDataArray]
                                    ?.length > 0 ? (
                                    <>
                                      {enableEdit ? (
                                        <div>
                                          <Form
                                            setOpenFormModal={closeEdit}
                                            defaultData={editData}
                                            envData={envData}
                                            formSchema={modalForm.update}
                                            modSchema={modalForm}
                                            crud={modalForm.crud}
                                            isLocalEnvironment={isLocalEnvironment}
                                          />
                                        </div>
                                      ) : deleteConfirm ? (
                                        <div>
                                          <div className="trtui-mt-2 trtui-text-center">
                                            <lord-icon
                                              src="https://cdn.lordicon.com/gsqxdxog.json"
                                              trigger="loop"
                                              colors="primary:#f7b84b,secondary:#f06548"
                                              style={{ width: '100px', height: '100px' }}
                                            />
                                            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                                              <h4>Are you Sure ?</h4>
                                              <p className="trtui-text-muted trtui-mx-4 trtui-mb-0">
                                                Are you sure, you want to delete this?
                                              </p>
                                            </div>
                                          </div>
                                          <div className="trtui-d-flex trtui-gap-2 trtui-justify-content-center trtui-mt-4 trtui-mb-2">
                                            <button
                                              type="button"
                                              className="trtui-btn trtui-w-sm trtui-btn-light"
                                              data-bs-dismiss="modal"
                                              disabled={deleteCallMutation.isLoading}
                                              onClick={() => {
                                                closeDelete()
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              type="button"
                                              className="trtui-btn trtui-w-sm trtui-btn-danger"
                                              disabled={deleteCallMutation.isLoading}
                                              onClick={() => onDelete()}
                                            >
                                              {deleteCallMutation.isLoading ? (
                                                <span className="trtui-d-flex trtui-align-items-center">
                                                  <span className="trtui-flex-grow-1 trtui-me-2">
                                                    Deleting...
                                                  </span>
                                                  <span
                                                    className="trtui-spinner-border trtui-flex-shrink-0"
                                                    role="status"
                                                  >
                                                    <span className="trtui-visually-hidden">
                                                      Deleting...
                                                    </span>
                                                  </span>
                                                </span>
                                              ) : (
                                                'Yes, Delete It!'
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="trtui-table-responsive trtui-mt-xl-0">
                                          <table className="trtui-table trtui-table-white trtui-table-striped trtui-table-nowrap trtui-align-middle trtui-mb-0">
                                            <thead>
                                              <tr>
                                                {modalForm.view.tableHeaders.map((h, hInd) => (
                                                  <th scope="col" key={hInd}>
                                                    {h}
                                                  </th>
                                                ))}
                                                {modalForm.view.noActions !== true &&
                                                  !modalForm.noActions && (
                                                    <th scope="col">Action</th>
                                                  )}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {defaultData.formData[currentPage - 1][
                                                modalForm.rowDataArray
                                              ]?.length &&
                                                defaultData.formData[currentPage - 1][
                                                  modalForm.rowDataArray
                                                ].length > 0 &&
                                                defaultData.formData[currentPage - 1][
                                                  modalForm.rowDataArray
                                                ].map((c, cInd) => (
                                                  <tr key={cInd}>
                                                    {modalForm.view.valFromObj
                                                      ? modalForm.view.obj.map((r, rInd) => (
                                                          <td key={rInd}>
                                                            {r.type && r.type === 'date'
                                                              ? dayjs(
                                                                  r.length > 1
                                                                    ? c[r[0]][r[1]]
                                                                    : c[r[0]],
                                                                ).format('MM-DD-YYYY')
                                                              : r.length > 1
                                                                ? c[r[0]][r[1]]
                                                                : c[r[0]]}
                                                          </td>
                                                        ))
                                                      : modalForm.view.tableRows.map((r, rInd) => (
                                                          <td key={rInd}>
                                                            {r.type && r.type === 'date'
                                                              ? dayjs(c[r.field]).format(
                                                                  'MM-DD-YYYY',
                                                                )
                                                              : c[r]}
                                                          </td>
                                                        ))}
                                                    <td>
                                                      {!modalForm.noActions && (
                                                        <div className="trtui-hstack trtui-gap-3 trtui-flex-wrap">
                                                          {!modalForm.noUpdate && (
                                                            <span
                                                              onClick={() => openEdit(c)}
                                                              className="trtui-link-success trtui-fs-15 trtui-cursor-pointer"
                                                            >
                                                              <i className="ri-edit-2-line" />
                                                            </span>
                                                          )}
                                                          {!modalForm.noDelete && (
                                                            <span
                                                              onClick={() =>
                                                                openDelete(c, modalForm)
                                                              }
                                                              className="trtui-link-danger trtui-fs-15 trtui-cursor-pointer"
                                                            >
                                                              <i className="ri-delete-bin-line" />
                                                            </span>
                                                          )}
                                                          <span
                                                            href={
                                                              modalForm.openNewWindowLink +
                                                              c[modalForm.openNewWindowLinkParam]
                                                            }
                                                            // onClick={() =>
                                                            //   newFormAdd(
                                                            //     c[modalForm.openNewWindowLinkParam],
                                                            //   )
                                                            // }
                                                            className="trtui-link-success trtui-fs-15"
                                                          >
                                                            {modalForm.openNewWindowLinkName}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </td>
                                                  </tr>
                                                ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </>
                                  ) : modalForm.noRowsIsSingle ? (
                                    <div>
                                      <Form
                                        setOpenFormModal={closeEdit}
                                        defaultData={
                                          defaultData.formData[currentPage - 1][
                                            modalForm.rowDataArray
                                          ]
                                        }
                                        envData={envData}
                                        formSchema={modalForm.update}
                                        modSchema={modalForm}
                                        crud={modalForm.crud}
                                        isLocalEnvironment={isLocalEnvironment}
                                      />
                                    </div>
                                  ) : (
                                    <div className="trtui-row trtui-g-2">
                                      <div className="trtui-col-12">No Data Found</div>
                                    </div>
                                  )}
                                </>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {(next < defaultData?.formData?.data?.length || next < defaultData?.formData?.length) &&
        modSchema.form?.view?.loadMore && (
          <div className="trtui-mb-4 trtui-text-center">
            <button
              type="button"
              className="trtui-btn trtui-btn-primary trtui-btn-md"
              onClick={handleMoreData}
            >
              Load More
            </button>
          </div>
        )}
      {(openFormModal || addMode === 'true') && (
        <FormModal
          setOpenFormModal={setOpenFormModal}
          crud={modSchema.form?.crud}
          envData={envData}
          formSchema={modSchema.form.create}
          modSchema={modSchema}
          moduleSchema={modSchema}
          isAdd={true}
          authDetails={authDetails}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {(openChildFormModal || addMode === 'true') && (
        <FormModal
          setOpenFormModal={childFormModalClose}
          crud={modSchema.form?.crud}
          envData={envData}
          formSchema={dataChildFormModal}
          modSchema={dataChildFormModal}
          moduleSchema={modSchema}
          isAdd={true}
          parentId={defaultData.formData[currentPage - 1][dataChildFormModal.parentId]}
          authDetails={authDetails}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {docManager && (
        <DocManager
          id={currentPage - 1}
          setOpenFormModal={setDocManager}
          formSchema={modSchema.form.update}
          modSchema={modSchema}
          defaultData={defaultData.formData[currentPage - 1]}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
          authDetails={authDetails}
          envData={envData}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {manageExamModal && (
        <Exams
          id={currentPage - 1}
          setOpenFormModal={setManageExamModal}
          formSchema={modSchema.form.update}
          modSchema={modSchema}
          defaultData={defaultData.formData}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
          authDetails={authDetails}
          envData={envData}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {manageExamScheduleModal && (
        <ExamSchedule
          id={currentPage - 1}
          setOpenFormModal={setManageExamScheduleModal}
          formSchema={modSchema.form.update}
          modSchema={modSchema}
          defaultData={defaultData.formData[currentPage - 1]}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
          authDetails={authDetails}
          envData={envData}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
    </React.Fragment>
  )
}

BasicForm.propTypes = {
  defaultData: PropTypes.object,
  setAllData: PropTypes.func,
  allData: PropTypes.object,
  envData: PropTypes.object,
  routeData: PropTypes.object,
  authDetails: PropTypes.object,
  modSchema: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
